import apiFetch from '../apiFetch'
export default function (token, body) {
  return apiFetch({ endPoint: 'Fleets/GetConditionsFleetList', method: 'POST', body: body, token: token })
}
